import { render } from "./PortfolioProject.vue?vue&type=template&id=55dad954&scoped=true"
import script from "./PortfolioProject.vue?vue&type=script&lang=js"
export * from "./PortfolioProject.vue?vue&type=script&lang=js"

import "./PortfolioProject.vue?vue&type=style&index=0&id=55dad954&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-55dad954"

export default script